<template>
  <div class='infobox' :style='boxStyle'>
    <!-- top half -->
    <div class='date'>
      <div>
        Day {{ index + 1 }}: {{ formattedDate}}
        <span v-if='index === featuredIndex'>
          ({{ getHour(currentTime) }})
        </span>
      </div>
    </div>

    <!-- bottom half -->
    <div class='info' :style='{marginTop: `${top}px`}'>
      <div v-show='!selected' class='keywords' :style='keywordsStyle'>
        <span v-for='(d, i) in data' :style='getKeywordStyle(d, i)'>
          <span style='font-size: 0.9em;'>{{i === 0 ? 'send me ' : ''}}</span>
          <span style='font-size: 0.9em; font-weight: 600;'>{{d.keyword}}</span>
          <span style='font-size: 0.6em'>{{ getTime(d.date) }}</span>
          {{i > 0 ? '//' : ''}}
        </span>
      </div>
      <div class='selected' :style='{visibility: selected ? `visible` : `hidden`}'>
        <div class='title' ref='selectedInfo'>
          <span style='font-size: 0.9em;'>send me </span>
          <span style='font-size: 0.9em; font-weight: 600;'>{{selected && selected.keyword}}</span>
          <span style='font-size: 0.6em'>{{ selected && getTime(selected.date) }}</span>
        </div>
        <div class='image' ref='selectedImage' />
        <div class='title' ref='selectedTitle' style='font-size: 0.9em;'>
          {{ selected && selected.artwork.artists.join(', ')}}<br />
          <em>{{ selected && selected.artwork.title }}</em><br />
          {{ selected && selected.artwork.date }}
          <br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {select, timeFormat, timeHour} from 'd3';

const margin = 5;
export default {
  name: 'Infobox',
  props: [
    'width', 'height', 'top', 'data',
    'formattedDate', 'currentTime', 'selected',
    'index', 'featuredIndex',
  ],
  data() {
    const size = 150;
    return {
      size,
      boxStyle: {width: '100%', height: `${this.height}px`},
      keywordsStyle: {
        height: `${this.height - 2 * margin}px`,
        'text-align': 'center',
      },
    };
  },
  updated: function() {
    // can only update image height after the titles have been updated
    let infoHeight = this.$refs.selectedInfo ? this.$refs.selectedInfo.offsetHeight : 0;
    infoHeight += this.$refs.selectedTitle ? this.$refs.selectedTitle.offsetHeight : 0;
    select(this.$refs.selectedImage)
      .style('height', `${this.height - 3 * margin - infoHeight}px`)
      .style('background-image', this.selected && `url(${this.selected.media})`)
  },
  methods: {
    getTime: function(time) {
      return timeFormat('%I:%M%p')(time);
    },
    getHour: function(time) {
      return timeFormat('%I%p')(timeHour.ceil(time));
    },
    getKeywordStyle: function(d, i) {
      return {
        opacity: (!this.selected && i === 0) ? 1 : 0.1,
        display: i === 0 ? 'block' : 'inline',
        // float: this.index > this.featuredIndex ? 'right' :
        //   (this.index === this.featuredIndex ? null : 'left'),
        // color: (this.index === this.featuredIndex && i === 0) ? '#ff483b' : null,
      };
    }
  },
}
</script>

<style scoped>
.date {
  position: absolute;
  top: 0;
  padding: 7px 5px 5px 5px;
  /* border-bottom: 1px solid rgba(68,73,76,0.2); */
  border-bottom: 1px solid;
}

.date .time {
  font-size: 1.5em;
}

.repeat {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 18px;
  cursor: pointer;
}

.info {
  position: relative;
  pointer-events: none;
}

.keywords {
  overflow: hidden;
  margin: 0 5px;
}

.selected {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
}

.selected .title {
  margin: 0 5px;
  padding: 2px;
  text-align: center;
}

.selected .image {
  width: calc(100% - 10px);
  margin: 0 5px;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
}

.keyword {
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Infobox.vue